module.exports = __webpack_public_path__ + "static/media/6_Event Information with ADA.826187fa.jpg";